export function unreachableError(data: never): never {
  throw data;
}

export function unreachableVariant(data: never): void {
  console.error('Unreachable variant', data);
}

export function silentUnreachableVariant(data: never): void {}
